// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__26wS9","actions":"GroupTable_actions__q3-0W","deleteModalFooter":"GroupTable_deleteModalFooter__1SzWy"};